import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import CoverCard from './CoverCard';
import BranchOfficeService from '../../../services/BranchOfficeService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  CoverCard: {
    height: '100%'
  }
}));

const CoverList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [covers, setCovers] = useState([]);

  const foo = async () => {
    const fetchData = typeof id !== 'undefined'
      ? await BranchOfficeService.getById(id)
      : await BranchOfficeService.getAllCovers();

    if (fetchData?.code === 200) {
      if (id) {
        setCovers([fetchData.data]);
      } else {
        setCovers(fetchData.data);
      }
    }
  };

  useEffect(() => {
    foo();
  }, []);

  useEffect(() => {
    if (id && id?.length > 0) {
      foo();
    }
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Covers de sucursales"
    >
      <Container maxWidth={false}>
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {covers.map((cover) => (
              <Grid
                item
                key={cover.id}
                lg={4}
                md={6}
                xs={12}
              >
                <CoverCard
                  onSuccess={foo}
                  className={classes.CoverCard}
                  branchOffice={cover}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default CoverList;
